export function pascalToCamel(pascalCaseString: string): string {
  if (!pascalCaseString) {
    return pascalCaseString;
  }
  return pascalCaseString?.charAt(0).toLowerCase() + pascalCaseString?.slice(1);
}
